// Mock data for DummyTicketExperts

// Airports sorted alphabetically by city name for better UX
const airportsData = [
  { iata: 'AUH', name: 'Abu Dhabi Intl', city: 'Abu Dhabi', country: 'UAE' },
  { iata: 'AMD', name: 'Ahmedabad', city: 'Ahmedabad', country: 'India' },
  { iata: 'AMS', name: 'Amsterdam Schiphol', city: 'Amsterdam', country: 'Netherlands' },
  { iata: 'ATH', name: 'Athens Intl', city: 'Athens', country: 'Greece' },
  { iata: 'BKK', name: 'Bangkok Suvarnabhumi', city: 'Bangkok', country: 'Thailand' },
  { iata: 'BLR', name: 'Bangalore', city: 'Bangalore', country: 'India' },
  { iata: 'BCN', name: 'Barcelona El Prat', city: 'Barcelona', country: 'Spain' },
  { iata: 'PEK', name: 'Beijing Capital Intl', city: 'Beijing', country: 'China' },
  { iata: 'EZE', name: 'Buenos Aires Ezeiza', city: 'Buenos Aires', country: 'Argentina' },
  { iata: 'CAI', name: 'Cairo Intl', city: 'Cairo', country: 'Egypt' },
  { iata: 'MAA', name: 'Chennai', city: 'Chennai', country: 'India' },
  { iata: 'ORD', name: "O'Hare Intl", city: 'Chicago', country: 'USA' },
  { iata: 'CPH', name: 'Copenhagen', city: 'Copenhagen', country: 'Denmark' },
  { iata: 'DFW', name: 'Dallas/Fort Worth Intl', city: 'Dallas', country: 'USA' },
  { iata: 'DEL', name: 'Delhi', city: 'Delhi', country: 'India' },
  { iata: 'DOH', name: 'Hamad Intl', city: 'Doha', country: 'Qatar' },
  { iata: 'DXB', name: 'Dubai Intl', city: 'Dubai', country: 'UAE' },
  { iata: 'FRA', name: 'Frankfurt', city: 'Frankfurt', country: 'Germany' },
  { iata: 'GOI', name: 'Goa', city: 'Goa', country: 'India' },
  { iata: 'HKG', name: 'Hong Kong Intl', city: 'Hong Kong', country: 'Hong Kong' },
  { iata: 'HYD', name: 'Hyderabad', city: 'Hyderabad', country: 'India' },
  { iata: 'IST', name: 'Istanbul', city: 'Istanbul', country: 'Turkey' },
  { iata: 'CGK', name: 'Jakarta Soekarno-Hatta', city: 'Jakarta', country: 'Indonesia' },
  { iata: 'JNB', name: 'Johannesburg OR Tambo', city: 'Johannesburg', country: 'South Africa' },
  { iata: 'COK', name: 'Kochi', city: 'Kochi', country: 'India' },
  { iata: 'CCU', name: 'Kolkata', city: 'Kolkata', country: 'India' },
  { iata: 'KUL', name: 'Kuala Lumpur Intl', city: 'Kuala Lumpur', country: 'Malaysia' },
  { iata: 'LGW', name: 'London Gatwick', city: 'London', country: 'UK' },
  { iata: 'LHR', name: 'London Heathrow', city: 'London', country: 'UK' },
  { iata: 'LAX', name: 'Los Angeles Intl', city: 'Los Angeles', country: 'USA' },
  { iata: 'MAD', name: 'Madrid Barajas', city: 'Madrid', country: 'Spain' },
  { iata: 'MEL', name: 'Melbourne', city: 'Melbourne', country: 'Australia' },
  { iata: 'SVO', name: 'Moscow Sheremetyevo', city: 'Moscow', country: 'Russia' },
  { iata: 'BOM', name: 'Mumbai', city: 'Mumbai', country: 'India' },
  { iata: 'MUC', name: 'Munich', city: 'Munich', country: 'Germany' },
  { iata: 'JFK', name: 'John F Kennedy Intl', city: 'New York', country: 'USA' },
  { iata: 'CDG', name: 'Charles de Gaulle', city: 'Paris', country: 'France' },
  { iata: 'PNQ', name: 'Pune', city: 'Pune', country: 'India' },
  { iata: 'FCO', name: 'Rome Fiumicino', city: 'Rome', country: 'Italy' },
  { iata: 'SFO', name: 'San Francisco Intl', city: 'San Francisco', country: 'USA' },
  { iata: 'PVG', name: 'Shanghai Pudong Intl', city: 'Shanghai', country: 'China' },
  { iata: 'SIN', name: 'Singapore Changi', city: 'Singapore', country: 'Singapore' },
  { iata: 'ICN', name: 'Seoul Incheon', city: 'Seoul', country: 'South Korea' },
  { iata: 'GRU', name: 'São Paulo Guarulhos', city: 'São Paulo', country: 'Brazil' },
  { iata: 'SYD', name: 'Sydney Kingsford Smith', city: 'Sydney', country: 'Australia' },
  { iata: 'NRT', name: 'Tokyo Narita', city: 'Tokyo', country: 'Japan' },
  { iata: 'YYZ', name: 'Toronto Pearson Intl', city: 'Toronto', country: 'Canada' },
  { iata: 'YVR', name: 'Vancouver Intl', city: 'Vancouver', country: 'Canada' },
  { iata: 'VIE', name: 'Vienna Intl', city: 'Vienna', country: 'Austria' },
  { iata: 'ZRH', name: 'Zurich', city: 'Zurich', country: 'Switzerland' }
];

export const airports = airportsData;

export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    location: 'Delhi, India',
    rating: 5,
    text: 'Got my visa approved! The dummy ticket service was quick and the PNR was verifiable. Received the ticket within 30 minutes.',
    date: '2 weeks ago'
  },
  {
    id: 2,
    name: 'Rahul Mehta',
    location: 'Mumbai, India',
    rating: 5,
    text: 'Excellent service for Schengen visa application. The hotel voucher along with flight reservation made my application complete. Highly recommended!',
    date: '1 month ago'
  },
  {
    id: 3,
    name: 'Anjali Desai',
    location: 'Bangalore, India',
    rating: 5,
    text: 'Very professional and affordable. Used it for my UK visa application and got approved without any issues. Thank you!',
    date: '3 weeks ago'
  },
  {
    id: 4,
    name: 'Vikram Singh',
    location: 'Hyderabad, India',
    rating: 5,
    text: 'Best dummy ticket service! Fast, reliable, and genuine PNR. Used it for immigration purposes and everything went smoothly.',
    date: '1 week ago'
  }
];

export const faqs = [
  {
    id: 1,
    question: 'What is a dummy ticket or flight reservation?',
    answer: 'A dummy ticket is a genuine, reserved flight itinerary with a verifiable reservation code (PNR) that can be checked on the airline website. It is a temporary booking that shows proof of your travel plans without requiring full payment for the ticket.'
  },
  {
    id: 2,
    question: 'Is it legal to use dummy tickets for visa applications?',
    answer: 'Yes, it is completely legal. Many embassies and consulates accept flight reservations or dummy tickets as proof of travel plans. They understand that travelers may not want to purchase expensive flight tickets before visa approval.'
  },
  {
    id: 3,
    question: 'How long is the dummy ticket valid?',
    answer: 'For visa purposes, the ticket is valid for 3-7 days. For immigration purposes (requiring a return flight), the reservation remains valid until your return flight date. This gives you enough time to complete your visa application or immigration process.'
  },
  {
    id: 4,
    question: 'What is the difference between visa and immigration purpose bookings?',
    answer: 'Visa purpose bookings (Rs. 999) are for visa applications and can be one-way or round-trip, valid for 3-7 days. Immigration purpose bookings (Rs. 4800) require a confirmed return flight and remain valid until your return date, used when entering a country that requires proof of onward travel.'
  },
  {
    id: 5,
    question: 'How quickly will I receive my ticket?',
    answer: 'Once you contact us via WhatsApp with your booking details, we typically provide your flight reservation with PNR within 30 minutes to 2 hours during business hours.'
  },
  {
    id: 6,
    question: 'Can I verify the PNR on the airline website?',
    answer: 'Yes! The PNR we provide is a genuine reservation that can be verified on the airline\'s official website. We create real bookings in the Global Distribution System (GDS), ensuring authenticity for your visa or immigration needs.'
  },
  {
    id: 7,
    question: 'Do you also provide hotel vouchers?',
    answer: 'Yes, we provide hotel reservation vouchers that can be used along with your flight reservation for visa applications. Hotel vouchers are included in our service packages.'
  },
  {
    id: 8,
    question: 'What payment methods do you accept?',
    answer: 'We accept various payment methods including UPI, bank transfer, and online payment gateways. Payment details will be shared when you contact us via WhatsApp.'
  }
];

export const hotelDestinations = [
  { id: 1, city: 'London', country: 'UK', popular: true },
  { id: 2, city: 'Paris', country: 'France', popular: true },
  { id: 3, city: 'Dubai', country: 'UAE', popular: true },
  { id: 4, city: 'New York', country: 'USA', popular: true },
  { id: 5, city: 'Singapore', country: 'Singapore', popular: true },
  { id: 6, city: 'Bangkok', country: 'Thailand', popular: false },
  { id: 7, city: 'Amsterdam', country: 'Netherlands', popular: false },
  { id: 8, city: 'Rome', country: 'Italy', popular: false },
  { id: 9, city: 'Barcelona', country: 'Spain', popular: false },
  { id: 10, city: 'Tokyo', country: 'Japan', popular: false }
];
